import { Component, Input, Output, EventEmitter, OnChanges, OnInit } from "@angular/core";
import { MenuItem } from 'primeng/api';
import { Object } from 'fabric/fabric-impl';

@Component({
  selector: "berth-operation-menu",
  templateUrl: "./berth-operation-menu.component.html",
  styleUrls: ["./berth-operation-menu.component.scss"],
})
export class BerthOperationMenuComponent implements OnInit, OnChanges {

  @Input()
  fabricObj: Object;

  /** EM-2589: navegação/retorno pelo mapa só para marina com movimentação. */
  @Input()
  movementsEnabled = false;

  aCoords: any;

  pixel_scale_m: number = 0.27777;

  @Output()
  onContextMenuItemClick: EventEmitter<any> = new EventEmitter<any>();

  onContextMenuClick(data): any {
    this.onContextMenuItemClick.emit({
      event, data
    });
  }

  items: MenuItem[];

  ngOnInit() {
    this.buildItems();
  }

  /**
   * EM-2589: com o menu aberto, um 2º clique direito em outra vaga só troca o `fabricObj` (o *ngIf não recria o
   * componente); os itens são remontados para não mostrar o estado da vaga anterior.
   */
  ngOnChanges() {
    this.buildItems();
  }

  private buildItems() {
    if (!this.fabricObj) {
      return;
    }
    this.aCoords = JSON.stringify(this.fabricObj.aCoords);
    this.items = [{
      label: 'Operação',
      items: [
        {
          label: 'Alocar Embarcação',
          icon: 'pi pi-sign-in',
          command: () => {
            this.onContextMenuClick({ 'action': 'set-boat', 'fabricObj': this.fabricObj });
          },
          disabled: this.fabricObj['esy.boatId']
        },          
        {
          label: 'Desalocar Embarcação',
          icon: 'pi pi-sign-in',
          command: () => {
            this.onContextMenuClick({ 'action': 'unset-boat', 'fabricObj': this.fabricObj });
          },
          disabled: !this.fabricObj['esy.boatId']
        },        
        /*
        {
          label: 'Atracar Embarcação',
          icon: 'pi pi-sign-in',
          command: () => {
            this.onContextMenuClick({ 'action': 'moored', 'fabricObj': this.fabricObj });
          }
        }, */
        ...(this.movementsEnabled ? this.navigationItems() : []),
        {
          label: 'info',
          icon: 'pi pi-info-circle',
          command: () => {
            this.onContextMenuClick({ 'action': 'info', 'fabricObj': this.fabricObj });
          }
        },         

      ]
    }
    ];
  }

  /**
   * Apontar Navegação só com barco na vaga, fora da navegação e sem plano criado pelo mapa com a saída pendente;
   * Apontar Retorno só com o barco navegando.
   */
  private navigationItems(): MenuItem[] {
    const boatId = this.fabricObj['esy.boatId'];
    const hasBoat = !!boatId;
    const onNavigation = !!this.fabricObj['esy.onNavigation'];
    const pendingPlan = hasBoat && this.fabricObj['esy.pendingPlanBoatId'] == boatId;
    return [
      {
        label: 'Apontar Navegação',
        icon: 'pi pi-sign-out',
        command: () => {
          this.onContextMenuClick({ 'action': 'navigation', 'fabricObj': this.fabricObj });
        },
        disabled: !hasBoat || onNavigation || pendingPlan,
        title: pendingPlan ? 'Plano já criado: conclua a saída pela tela de Movimentação' : undefined
      },
      {
        label: 'Apontar Retorno',
        icon: 'pi pi-refresh',
        command: () => {
          this.onContextMenuClick({ 'action': 'nav-return', 'fabricObj': this.fabricObj });
        },
        disabled: !hasBoat || !onNavigation
      },
    ];
  }


}
